import React from 'react';
import { MessageSquare, PlayCircle, FileText, Target, TrendingUp, Activity } from 'lucide-react';
import { useOutletContext } from "react-router-dom";
const StatCard = ({ title, value, change, color, icon: IconComponent }) => (
  <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-gray-600 font-semibold text-sm uppercase tracking-wide">{title}</h3>
      <div className={`p-3 rounded-xl ${color}`}>
        <IconComponent size={24} className="text-white" />
      </div>
    </div>
    <div className="space-y-2">
      <div className="text-3xl font-bold text-gray-800">{value}</div>
      <div className="flex items-center gap-2 text-sm">
        <TrendingUp size={16} className="text-green-500" />
        <span className="text-green-500 font-semibold">{change}</span>
        <span className="text-gray-500">from last week</span>
      </div>
    </div>
  </div>
);

const RecentActivity = () => (
  <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
    <h3 className="text-xl font-bold text-gray-800 mb-6">Recent Activity</h3>
    <div className="space-y-4">
      {[
        { action: 'New transcript processed', session: 'Digital Banking Panel', time: '2 min ago', color: 'bg-blue-500' },
        { action: 'Session updated', session: 'AI in Finance Workshop', time: '15 min ago', color: 'bg-green-500' },
        { action: 'Speaker added', session: 'ESG Investment Strategies', time: '1 hour ago', color: 'bg-purple-500' },
        { action: 'Query processed', session: 'User asked about schedule', time: '2 hours ago', color: 'bg-orange-500' },
      ].map((activity, index) => (
        <div key={index} className="flex items-center gap-4 p-3 rounded-lg hover:bg-gray-50 transition-colors">
          <div className={`w-3 h-3 rounded-full ${activity.color}`} />
          <div className="flex-1">
            <div className="font-semibold text-gray-800">{activity.action}</div>
            <div className="text-sm text-gray-600">{activity.session}</div>
          </div>
          <div className="text-sm text-gray-500">{activity.time}</div>
        </div>
      ))}
    </div>
  </div>
);

const Overview = () => {
  const { darkMode } = useOutletContext();
  return (
    <div className="space-y-8 p-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className={`text-3xl font-bold ${ darkMode ? "text-gray-100" : "text-gray-800"}`}>Dashboard Overview</h1>
          <p className={`mt-2 ${ darkMode ? "text-gray-300" : "text-gray-600"}`}>Monitor your AI Doctor Assistant performance</p>
        </div>
        {/* <div className="flex items-center gap-3">
          <button className="px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition-colors">
            Export Report
          </button>
        </div> */}
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard
          title="Total Queries"
          value="2,847"
          change="+12%"
          icon={MessageSquare}
          color="bg-gradient-to-r from-blue-500 to-blue-600"
        />
        <StatCard
          title="Active Sessions"
          value="24"
          change="+3 new"
          icon={PlayCircle}
          color="bg-gradient-to-r from-green-500 to-green-600"
        />
        <StatCard
          title="Processed Transcripts"
          value="156"
          change="+18"
          icon={FileText}
          color="bg-gradient-to-r from-purple-500 to-purple-600"
        />
        <StatCard
          title="Response Accuracy"
          value="94.2%"
          change="+2.1%"
          icon={Target}
          color="bg-gradient-to-r from-orange-500 to-orange-600"
        />
      </div>

      {/* Charts and Activity */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
          <h3 className="text-xl font-bold text-gray-800 mb-6">Query Trends</h3>
          <div className="h-64 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl flex items-center justify-center">
            <div className="text-center">
              <Activity size={48} className="text-indigo-500 mx-auto mb-4" />
              <p className="text-gray-600">Chart will be rendered here</p>
              {/* <p className="text-sm text-gray-500">Integration with Chart.js or Recharts</p> */}
            </div>
          </div>
        </div>
        <RecentActivity />
      </div>
    </div>
  );
};


export default Overview;